export function handleImageError(fallback: string = '/static/images/thumbnails/default-user.jpg') {
	return (event: Event) => {
		const img = event.target as HTMLImageElement;
		if (img.src !== fallback) {
			img.src = fallback;
		}
	};
}
